import type {CitationDataService} from './citation.data-service';
import type {LabeledIdentified, Rec} from 'typings/portaro.be.types'
import type {Citation, CitationCitacePro} from './types';


export class CitationPresenter {
    public static presenterName = 'citationPresenter';

    /*@ngInject*/
    constructor(private citationDataService: CitationDataService) {}

    public getCitation(record: Rec, style?: LabeledIdentified<string>): Promise<Citation | CitationCitacePro> {
        return this.citationDataService.getCitation(record, style);
    }
}